import React from "react";
import cs from "classnames";
import { FormattedMessage } from "react-intl";

import { seeMoreEventsText } from "@stubhub/react-event-helper";
import EventList from "@stubhub/react-event-list";
import FormattedLink from "@stubhub/react-formatted-link";
import Panel from "@stubhub/react-panel";
import Spinner from "@stubhub/react-spinner";
import { ToggleSwitch } from "@stubhub/react-toggle-switch";

import RequestEventsComponent from "../../react-request-events";

import "../index.scss";

const SellListPanelLayout = (props) => {
  const {
    numFound = 0,
    events = [],
    loading = false,
    hasMore,
    enableViewTickets,
    eventItemDisplayOptions,
    disablePagination,
    className,
    hideBorder,
    isSell,
    loadMore,
    numSelectedEvents,
    onEventItemCheckboxClick,
    onSelectAllCheckboxClick,
    isSelectAllChecked,
    disableMultipleEventsSwitch,
    onToggleClicked,
    isMultipleEventToggleSelected,
    selectedEvents,
    selectAllRef,
    storeId,
  } = props;

  const firstLoading = loading && numFound === 0;
  const showNoEventsFoundModule = !numFound;
  const sellPanelClassNames = cs(
    isSell
      ? `Panel__HeaderSell ${isMultipleEventToggleSelected ? "SellToggleOn" : ""
      } ${events && events.length > 1 ? "" : "Panel__HeaderSell-no-results"}`
      : ""
  );

  // Header
  const header = (
    <div className="">
      <div className="EventListPanel__Header">
        <div className="EventListPanel__HeaderText EventListPanel__HeaderTextSell">
          <FormattedMessage
            id="SearchResults.AllLocations"
            defaultMessage="{numFound} events in all locations"
            values={{ numFound }}
          />
        </div>
        {!disableMultipleEventsSwitch && (
          <div
            className={cs(
              "EventListPanel__ToggleContainer",
              isMultipleEventToggleSelected
                ? "EventListPanel__ToggleChecked"
                : ""
            )}
          >
            <ToggleSwitch
              label="Multiple events"
              isChecked={isMultipleEventToggleSelected}
              onClick={onToggleClicked}
            />
          </div>
        )}
      </div>
      <div
        className={cs(
          "EventListPanel__SelectAllCheckboxContainer",
          !isMultipleEventToggleSelected ||
            numFound <= 0 ||
            numSelectedEvents === 0
            ? "hidden"
            : "EventListPanel__ToggleChecked"
        )}
      >
        <div className="EventListPanel__SelectAll-Label">
          <FormattedMessage
            id="SearchResults.SelectAll"
            defaultMessage="Select All"
          />
        </div>
        <div className={cs("EventListPanel__SelectAllCheckboxParent")}>
          {/* Very tricky checkbox for select all

            Checked use cases: if user has not selected any event as of yet, then its value depends on numSelectedEvents
                                else, if user has selected atleast 1 event, then we save the ref of the checkbox in parent
                                   and have to manually control its checking

                    Two tricky use cases are:
                    1. the isSelectAllChecked condition above
                    2. if user has clicked on this checkbox, then toggles off the Multiple Events toggle, then toggles it on again
                          then this checkbox should be unchecked
          */}
          <input
            name="EventListPanel__SelectAllCheckbox"
            type="checkbox"
            id="EventListPanel__SelectAllCheckbox"
            ref={(checkbox) => selectAllRef(checkbox)}
            checked={
              Object.keys(selectedEvents).length > 0
                ? isSelectAllChecked
                : numSelectedEvents
            }
            disabled={!numSelectedEvents}
            onChange={(e) => onSelectAllCheckboxClick(e.target.checked)}
          />
          <label htmlFor="EventListPanel__SelectAllCheckbox" />
        </div>
      </div>
    </div>
  );

  // Event List
  const eventList = showNoEventsFoundModule ? (
    <RequestEventsComponent storeId={storeId} />
  ) : (
    <EventList
      className="EventResult"
      events={events}
      selectedEvents={selectedEvents}
      threshold={100}
      enableViewTickets={enableViewTickets}
      eventItemDisplayOptions={eventItemDisplayOptions}
      isSell={isSell}
      onEventItemCheckboxClick={onEventItemCheckboxClick}
      isMultipleEventToggleSelected={isMultipleEventToggleSelected}
    />
  );

  // Footer
  const footer =
    !disablePagination && hasMore && !showNoEventsFoundModule ? (
      <FormattedLink className="EventListPanel__Footer" onClick={loadMore}>
        {loading ? <Spinner /> : seeMoreEventsText}
      </FormattedLink>
    ) : null;

  // Return the component with the Header, Event List and Footer
  return firstLoading ? (
    <Spinner />
  ) : (
    <Panel
      className={cs(className || "EventListPanel")}
      footer={footer}
      header={header}
      content={eventList}
      border={!hideBorder}
      sellClassNames={sellPanelClassNames}
    />
  );
};

export default SellListPanelLayout;
